import axios from "axios";

export class PowerUpsService {
  async loginPowerUps() {
    const url = process.env.VUE_APP_POWERUPS_API;
    return await axios
      .post(`${url}api/login_check`, {
        username: process.env.VUE_APP_POWERUPS_USER_NAME, 
        password: process.env.VUE_APP_POWERUPS_KEY,
      })
      .then((res) => {
        localStorage.setItem("powerToken", res.data.token);
      });
  }
  async getPowerUpsNotification(userId, spaceId) {
    const url = process.env.VUE_APP_POWERUPS_API;
    const token = localStorage.getItem("token");
    await this.loginPowerUps();
    const reqInstance = axios.create({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("powerToken")}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return await reqInstance.get(
      `${url}api/v1/user_notification?userID=${userId}&companyID=${spaceId}&nubiToken=${token}`
    );
  }
}
